// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"31fb1df0","703":"dcdc771c"}[chunkId] + ".chunk.js";
};